import { breakpoints } from '../utils';

const openItem = ($item) => {
    const $content = $item.find('[data-accordion-item-content]');

    $item.attr('data-active', 1);

    gsap.set(
        $content,
        {
            display: 'block',
        }
    );

    gsap.fromTo(
        $content,
        {
            height: 0,
        },
        {
            height: 'auto',
            ease: 'none',
            duration: 0.3,
        }
    );
};

const closeItem = ($item) => {
    const $content = $item.find('[data-accordion-item-content]');

    $item.attr('data-active', 0);

    gsap.to(
        $content,
        {
            height: 0,
            onComplete: () => {
                gsap.set(
                    $content,
                    {
                        display: 'none',
                    }
                );
            },
        }
    );
};

const closeActiveItem = ($accordion) => {
    const $activeItem = (
        $accordion.find('[data-accordion-item][data-active="1"]')
    );
    closeItem($activeItem);
};

const initializeAccordions = () => {

    $('[data-accordion]').each(function() {
        const $accordion = $(this);
        const startsOpen = $accordion.is('[data-starts-open]');
        const isMultiExpandable = $accordion.is('[data-multi-expand]');
        const $toggle = $accordion.find('[data-accordion-item-toggle]');
        const $item = $accordion.find('[data-accordion-item]');

        let enterTimer = null;
        let exitTimer = null;
        const enterDelay = 300;
        const exitDelay = 100;

        closeActiveItem($accordion);

        $item.off();
        $toggle.off();

        $toggle.click(function() {
            const $item = $(this).parents('[data-accordion-item]');

            const isActive = $item.attr('data-active') == 1;

            if (!isActive) {

                if (!isMultiExpandable) {
                    closeActiveItem($accordion);
                }

                openItem($item);
            } else {
                closeItem($item);
            }
        });

        if (startsOpen) {
            openItem($accordion.find('[data-accordion-item]').first());
        }
        
    });
};

const initialize = () => {

    initializeAccordions();

    $(window).resize(() => {
        initializeAccordions();
    });
};

export default {
    initialize
};

